module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ;  
    var listService = require('ListService.js').default;
    var sales = listService.salesEmailAddress;

    ; __append("\r\n\r\n<div id=\"notificationEmailAttachmentModal\" title=\"Attachments\" style=\"display: none;\">\r\n\r\n    <div class=\"row\" style=\"padding: 0 0 10px 15px; width: 100%\">\r\n        <div class=\" col-md-12\" id=\"text1\">\r\n            The Attachments feature is not enabled on your account. \r\n            Contact ")
    ; __append(escapeFn(sales ))
    ; __append(" for more information.\r\n        </div>\r\n    </div>    \r\n</div>\r\n")
  }
  return __output;

}